// 0: 等待審核
// 1: 通過
// 2: 未通過
const ENTRY_VERIFY_WAITING = 0;
const ENTRY_VERIFY_PASSED = 1;
const ENTRY_VERIFY_NOT_PASS = 2;

export const entryVerifyStatus = {
    WAITING: ENTRY_VERIFY_WAITING,
    PASSED: ENTRY_VERIFY_PASSED,
    NOT_PASS: ENTRY_VERIFY_NOT_PASS
};

// 假設 deletedAt 為 null 的話代表該紀錄沒有被刪除 (未通過)，反之則未通過
// 若 deletedAt 為 null 且 qualified 沒有日期 (undefined) 則表示待審核，反之代表通過
export const getEntryVerifyStatus = ({ deletedAt = null, qualified = true } = {}) =>
    deletedAt === null
        ? Boolean(qualified)
            ? entryVerifyStatus.PASSED
            : entryVerifyStatus.WAITING
        : entryVerifyStatus.NOT_PASS;
